import { Translation, QRType } from '../types';

export const de: Translation = {
  nav: {
    generator: 'Generator',
    scanner: 'Scanner',
    mobile: 'Auf dem Handy testen',
    blog: 'Blog',
    langSelect: 'Sprache wählen',
  },
  pageTitles: {
    generator: 'Kostenloser QR-Code-Generator Online',
    scanner: 'Online-QR-Code-Scanner',
    textToQr: 'Text in QR-Code umwandeln',
    linkToQr: 'Link in QR-Code Generator',
  },
  pageMeta: {
    generator: {
      title:
        'Kostenloser QR-Code-Generator – Erstelle QR-Codes online (Ohne Registrierung, Ohne Wasserzeichen, PNG/SVG/PDF) | YesQRCode',
      description:
        'Erstelle kostenlos QR-Codes online mit YesQRCode. Generiere URLs, Text, WLAN, vCard und mehr. Lade hochwertige PNG-, SVG- oder PDF-Dateien herunter. Keine Registrierung, kein Login, kein Wasserzeichen – schnell, sicher und dauerhaft kostenlos.',
      keywords: [
        'qr-code-generator',
        'kostenloser qr-code-generator',
        'qr-code online erstellen',
        'qr-code gratis generieren',
        'qr-code png',
        'qr-code svg',
        'qr-code pdf',
        'hochauflösender qr-code',
        'wifi qr-code generator',
        'vcard qr-code generator',
        'url qr-code generator',
        'qr-code maker gratis',
        'qr-generator ohne registrierung',
        'qr-generator ohne login',
        'qr-generator ohne wasserzeichen',
      ],
    },
    scanner: {
      title:
        'Online-QR-Code-Scanner – Scanne per Bild oder Kamera (Sicher, Ohne Registrierung) | YesQRCode',
      description:
        'Scanne QR-Codes und Barcodes online kostenlos. Lade ein Bild hoch oder nutze deine Kamera. Die Verarbeitung erfolgt vollständig lokal ohne Uploads. Sicher, schnell, ohne Registrierung, ohne Login und komplett kostenlos.',
      keywords: [
        'qr-code-scanner',
        'qr-code online scannen',
        'online qr-reader',
        'qr-code aus bild scannen',
        'barcode online scannen',
        'sicherer qr-scanner',
        'qr-scanner ohne upload',
        'kostenloser qr-scanner',
        'browser-basierter qr-scanner',
        'qr-scanner ohne registrierung',
        'qr-scanner ohne login',
      ],
    },
    textToQr: {
      title: 'Text-zu-QR-Code-Konverter — Reinen Text sofort in QR-Codes verwandeln | YesQRCode',
      description:
        'Wandle Notizen, Nachrichten oder beliebigen Text online in QR-Codes um. Passe Farben, Rahmen und Logos an und lade PNG-, SVG- oder PDF-Dateien ohne Registrierung herunter.',
      keywords: [
        'text zu qr code',
        'text in qr umwandeln',
        'text qr generator',
        'qr code aus text',
        'nachricht zu qr code',
        'notiz qr code',
        'text qr kostenlos',
        'text qr ohne registrierung',
        'qr text converter',
        'text qr online',
      ],
    },
    linkToQr: {
      title: 'Link-zu-QR-Code-Generator — URLs in QR-Codes umwandeln (UTM Ready) | YesQRCode',
      description:
        'Füge eine Website- oder Kampagnen-URL ein und erhalte sofort einen gebrandeten QR-Code. Unterstützt eigene Farben, Logos sowie hochauflösende PNG-, SVG- und PDF-Downloads ohne Login.',
      keywords: [
        'link zu qr code',
        'url in qr code',
        'qr code für website',
        'link qr generator',
        'utm qr code',
        'url qr kostenlos',
        'qr für kampagnen',
        'website qr erstellen',
        'url qr ohne registrierung',
        'link qr maker',
      ],
    },
  },
  hero: {
    title: 'Generieren. Scannen. Gestalten.',
    subtitle: 'Das Premium-Tool für QR-Codes – für jedes Team.',
    desc: 'Erstellen Sie QR-Codes mit Logos, eigenen Farben und Export in Druckauflösung – in wenigen Sekunden.',
  },
  info: {
    helpTitle: 'Hilfe & Support',
    helpSubtitle: 'Antworten auf häufige Fragen',
    contactTitle: 'Kontakt aufnehmen',
    contactSubtitle: 'Wir freuen uns auf Ihre Nachricht.',
    privacyTitle: 'Datenschutzerklärung',
    termsTitle: 'Nutzungsbedingungen',
  },
  contactForm: {
    name: 'Name',
    email: 'E-Mail',
    message: 'Nachricht',
    send: 'Nachricht senden',
    orEmail: 'oder direkt per E-Mail an',
    sending: 'Wird gesendet...',
    successTitle: 'Nachricht verschickt!',
    successMessage: 'Vielen Dank. Wir melden uns schnellstmöglich.',
    sendAnother: 'Weitere Nachricht senden',
    errorMessage: 'Nachricht konnte nicht gesendet werden. Bitte schreib an support@yesqrcode.com.',
  },
  generator: {
    highlights: {
      title: 'Private, markenreife QR-Codes erstellen – für immer kostenlos.',
      subtitle: 'Ein schnelles, sicheres und flexibles QR-Tool für jeden Workflow.',
      desc: 'Erzeugen und scannen Sie hochwertige QR-Codes ohne Konto, Wasserzeichen oder Daten-Uploads.',
      items: [
        {
          title: 'Datenschutz zuerst, alles lokal',
          desc: 'QR-Codes entstehen direkt auf Ihrem Gerät – keine Uploads, kein Tracking, keine Speicherung.',
        },
        {
          title: 'Funktionsvielfalt für jeden Einsatz',
          desc: 'URLs, WLAN, vCards, Barcodes, Logos, Farbverläufe, Rahmen – alles sofort verfügbar.',
        },
        {
          title: 'Optimiert für Mobilgeräte',
          desc: 'Für Smartphones und Touch optimiert, damit Erstellen und Scannen überall klappt.',
        },
        {
          title: 'Dauerhaft gratis für Teams & Marken',
          desc: 'Kein Konto, keine Wasserzeichen, keine Scan-Limits – zuverlässig für Unternehmen jeder Größe.',
        },
      ],
    },
    featureSuite: {
      title: 'Die komplette QR-Suite mit Datenschutzfokus',
      subtitle: 'Alles für saubere, gebrandete und hochqualitative QR-Codes – an einem Ort.',
      categories: [
        {
          title: 'Alle QR-Code-Typen, die Sie brauchen',
          body: 'URL, Text, WLAN, E-Mail, Telefon, SMS, vCard, Social Links, YouTube, Barcodes. Statische Codes ohne Ablaufdatum.',
          items: [],
        },
        {
          title: 'Branding & Design',
          body: 'Logo-sichere Codes, Farbverläufe, Rahmen, Formen, Ecken und scan-optimierte Layouts.',
          items: [],
        },
        {
          title: 'Ausgabe & Qualität',
          body: 'PNG, SVG und PDF in hoher Qualität mit Presets für Print und Digital.',
          items: [],
        },
        {
          title: 'Global & Usability',
          body: 'Mehrsprachige UI, Mobile-First und offline-freundliche Workflows.',
          items: [],
        },
      ],
    },
    trust: {
      title: 'Trusted by creators, teams, and brands',
      subtitle:
        'YesQRCode is designed to be lightweight, predictable, and safe for long-running campaigns — with no accounts, no vendor lock-in, and no hidden limitations.',
      items: [
        'Zero onboarding',
        'Predictable static codes',
        'Enterprise-safe: no cloud processing',
        'Consistent branding across all assets',
      ],
    },
    sectionContent: 'Inhalt',
    sectionColors: 'Farben',
    sectionLogo: 'Logo',
    sectionFrame: 'Rahmen',
    sectionDesign: 'Design',
    sectionCorrection: 'Fehlerkorrektur',
    labelUrl: 'Website-URL',
    labelText: 'Text',
    labelSsid: 'Netzwerkname (SSID)',
    labelPassword: 'Passwort',
    labelEncryption: 'Verschlüsselung',
    labelFgColor: 'Vordergrundfarbe',
    labelBgColor: 'Hintergrundfarbe',
    labelFrameText: 'Rahmentext',
    labelFrameColor: 'Rahmenfarbe',
    placeholder: 'Inhalt hier eingeben...',
    placeholders: {
      url: 'https://beispiel.de',
      text: 'Text eingeben',
      email: 'sie@example.com',
      subject: 'Betreff',
      message: 'Ihre Nachricht...',
      phone: '+49 170 000000',
      ssid: 'MeinWLAN',
      password: 'Passwort',
      barcode: '123456789012',
    },
    download: 'PNG herunterladen',
    downloadSvg: 'SVG herunterladen',
    generateButton: 'QR-Code erstellen',
    copy: 'SVG kopieren',
    uploadLogo: 'Bild hochladen',
    preview: 'Vorschau',
    lowQuality: 'Geringe Qualität',
    highQuality: 'Hohe Qualität',
    foreverFree: 'Für immer kostenlos • Keine Registrierung • Kommerziell nutzbar',
    barcodeWarning: 'Rahmen- und Logo-Optionen stehen für Barcodes nicht zur Verfügung.',
    barcodeColors: 'Farbanpassungen sind weiterhin möglich.',
    frameStyles: {
      none: 'Kein Rahmen',
      simple: 'Einfach',
      balloon: 'Sprechblase',
      box: 'Box',
      badge: 'Plakette',
      polaroid: 'Polaroid',
      phone: 'Smartphone',
      header: 'Header',
      corner: 'Ecken',
    },
    vCard: {
      firstName: 'Vorname',
      lastName: 'Nachname',
      mobile: 'Mobil',
      phone: 'Telefon',
      fax: 'Fax',
      email: 'E-Mail',
      company: 'Firma',
      job: 'Position',
      street: 'Straße',
      city: 'Stadt',
      zip: 'PLZ',
      state: 'Bundesland',
      country: 'Land',
      website: 'Website',
    },
    types: {
      [QRType.URL]: 'URL',
      [QRType.TEXT]: 'Text',
      [QRType.EMAIL]: 'E-Mail',
      [QRType.PHONE]: 'Telefon',
      [QRType.SMS]: 'SMS',
      [QRType.WIFI]: 'WLAN',
      [QRType.VCARD]: 'vCard',
      [QRType.FACEBOOK]: 'Facebook',
      [QRType.TWITTER]: 'X (Twitter)',
      [QRType.YOUTUBE]: 'YouTube',
      [QRType.BARCODE]: 'Barcode',
    },
    guide: {
      title: 'So erstellen Sie einen individuellen QR-Code',
      steps: [],
    },
    gettingStarted: {
      title: 'In vier Schritten fertig',
      steps: [
        {
          title: 'Inhalt wählen',
          text: 'Wählen Sie oben den QR-Typ und füllen Sie alle Felder aus, die nach dem Scannen erscheinen sollen.',
        },
        {
          title: 'Design anpassen',
          text: 'Passen Sie Farben, Formen und Logo an, damit der Code perfekt zu Ihrer Marke passt.',
        },
        {
          title: 'QR-Code generieren',
          text: 'Legen Sie die Auflösung fest, prüfen Sie die Live-Vorschau und testen Sie den Code direkt.',
        },
        {
          title: 'Export & Nutzung',
          text: 'Laden Sie PNG oder SVG herunter und verwenden Sie den Code in Print-, Verpackungs- oder Online-Kampagnen.',
        },
      ],
    },
    about: {
      title: 'Der kostenlose QR-Code-Generator für Profis',
      subtitle:
        'YesQRCode kombiniert unbegrenzte Scans, hochwertige Exporte und flexible Gestaltung, ideal für Marketing-Teams und Kreative.',
      features: [
        'QR-Codes für Social Media & Landing Pages',
        'Digitale Visitenkarten (vCard)',
        'Anpassbare Farben und Formen',
        'Druckfertige Exportformate',
        'Kommerzielle Nutzung erlaubt',
        'Unbegrenzte Lebensdauer',
      ],
      content: [
        {
          title: 'Keine Ablaufdaten',
          body: 'Statische QR-Codes funktionieren dauerhaft – keine Limits, keine versteckten Gebühren.',
        },
        {
          title: 'Mit Logo & Branding',
          body: 'Fügen Sie Ihr Logo hinzu und nutzen Sie bis zu 30 % Fehlerkorrektur für maximale Lesbarkeit.',
        },
        {
          title: 'Individuelles Design',
          body: 'Definieren Sie Formen, Farbverläufe und Rahmen, um mehr Aufmerksamkeit zu erzielen.',
        },
        {
          title: 'Druckqualität',
          body: 'PNG in hoher Auflösung oder SVG für perfekte Ergebnisse auf Postern, Verpackungen und POS-Materialien.',
        },
        {
          title: 'Kommerzielle Freiheit',
          body: 'Setzen Sie die Codes in Kampagnen, Gutscheinen und Produkten ohne rechtliche Einschränkungen ein.',
        },
      ],
    },
    faq: {
      title: 'Häufige Fragen',
      items: [
        { q: 'Was ist ein QR-Code?', a: 'Ein zweidimensionaler Code, der URLs oder Text speichert und 1994 entwickelt wurde.' },
        {
          q: 'Ist der Generator kostenlos?',
          a: 'Ja. Sie dürfen unbegrenzt Codes für private und geschäftliche Zwecke erstellen.',
        },
        {
          q: 'Kann ich den Code nachträglich ändern?',
          a: 'Nein, statische Codes lassen sich nicht bearbeiten. Erstellen Sie bei Änderungen einen neuen QR.',
        },
        { q: 'Gibt es Scan-Limits?', a: 'Nein. Jeder Code kann unbegrenzt oft gescannt werden.' },
        {
          q: 'Speichert YesQRCode meine Daten?',
          a: 'Nein. Dateien werden nur kurzzeitig zwischengespeichert, um Downloads zu beschleunigen.',
        },
        {
          q: 'Mein vCard-Code zeigt falsche Felder.',
          a: 'Manche Apps interpretieren vCard-Daten anders. Testen Sie bitte eine alternative Scanner-App.',
        },
        {
          q: 'Der Code funktioniert nicht – was tun?',
          a: 'Prüfen Sie auf Tippfehler, genügend Kontrast und testen Sie den Code einmal ohne Logo.',
        },
        {
          q: 'Welche Browser werden unterstützt?',
          a: 'Chrome, Firefox, Safari und Edge in aktuellen Versionen funktionieren am besten.',
        },
      ],
    },
  },
  scanner: {
    title: 'QR- & Barcode-Scanner',
    subtitle: 'Scannen Sie über Kamera, Upload oder Einfügen aus der Zwischenablage.',
    cameraPermission: 'Bitte erlauben Sie den Kamerazugriff in den Browser-Einstellungen.',
    result: 'Ergebnis',
    copy: 'Kopieren',
    copied: 'Kopiert',
    open: 'Link öffnen',
    delete: 'Löschen',
    scanAgain: 'Weitere Aufnahme',
    privacy: 'Alle Daten bleiben auf Ihrem Gerät. Es werden keine Bilder hochgeladen.',
    upload: 'Bild hochladen',
    paste: 'Einfügen (Strg+V)',
    drop: 'Bild hier ablegen',
    retry: 'Erneut versuchen',
    errorAccessDenied: 'Zugriff verweigert',
    errorCamera: 'Aktivieren Sie den Kamerazugriff und versuchen Sie es erneut.',
    initializing: 'Kamera startet...',
    cameraActive: 'Kamera aktiv',
    scannedItems: 'Gespeicherte Scans',
    recentScans: 'Zuletzt (lokal gespeichert)',
    clickToUpload: 'Klicken zum Hochladen',
    newBadge: 'NEU',
    tabCameraMobile: 'Kamera',
    tabCameraDesktop: 'Mit Kamera scannen',
    emptyState: {
      title: 'Noch keine Scans',
      desc: 'Laden Sie eine Datei hoch oder wechseln Sie auf die Kamera-Ansicht.',
    },
    highlights: {
      title: 'Schnelles, privates Scannen',
      items: [
        { title: 'Lokale Decodierung', desc: 'Standardmäßig keine Uploads – sicher für sensible URLs und Assets.' },
        { title: 'Viele Formate', desc: 'QR plus UPC/EAN, Code 128, ITF und weitere Standards.' },
        { title: 'Schnelle Aktionen', desc: 'Dateien ablegen, Screenshots einfügen oder sofort zum Live-Scan wechseln.' },
        { title: 'Optimiert für Mobilgeräte', desc: 'Optimierte UI und Kameraführung für Smartphones und kleine Displays.' },
      ],
    },
    intro: {
      title: 'Sicherer Online-Scanner',
      body: 'Lesen Sie QR-Codes, UPC, EAN, ITF und weitere Formate direkt im Browser.',
    },
    howTo: {
      title: 'So funktioniert es',
      methods: [
        {
          title: 'Upload',
          steps: ['Auf „Bild hochladen“ klicken', 'Datei auswählen', 'Ergebnis erscheint sofort'],
        },
        {
          title: 'Kamera',
          steps: ['Kamera-Tab öffnen', 'Zugriff erlauben', 'Code in den Rahmen halten'],
        },
      ],
    },
    features: {
      title: 'Vorteile',
      items: [
        { title: 'Kostenlos & unbegrenzt', desc: 'Keine Paywalls oder Limits.' },
        { title: 'Viele Formate', desc: 'Unterstützt QR, Code 128, UPC, EAN, ITF u. v. m.' },
        { title: 'Privatsphäre', desc: 'Verarbeitung ausschließlich im Browser.' },
      ],
    },
    useCases: {
      title: 'Einsatzmöglichkeiten',
      items: [
        { title: 'Marketing & Events', desc: 'Materialien prüfen und Conversion-Links testen.' },
        { title: 'Logistik & Lager', desc: 'Barcodes für Bestände und Lieferungen kontrollieren.' },
        { title: 'Alltag', desc: 'Menüs, Wi-Fi-Zugänge oder Formulare sicher öffnen.' },
      ],
    },
    faq: {
      title: 'Scanner-FAQ',
      items: [
        { q: 'Unterstützt ihr Barcodes?', a: 'Ja, sowohl eindimensionale als auch 2D-Codes werden erkannt.' },
        { q: 'Kann ich Screenshots einfügen?', a: 'Ja. Nutzen Sie Strg+V bzw. Cmd+V, um Bilder aus der Zwischenablage zu scannen.' },
        { q: 'Werden die Ergebnisse gespeichert?', a: 'Nur lokal in Ihrem Browser. Sie können die Liste jederzeit löschen.' },
        { q: 'Funktioniert der Scanner offline?', a: 'Uploads funktionieren offline; Kamera-Scan benötigt Berechtigungen und Browser-Support.' },
      ],
    },
  },
  blog: {
    title: 'Insights & Leitfäden',
    subtitle: 'Strategien, Inspiration und Neuigkeiten rund um QR-Codes.',
    readMore: 'Artikel lesen',
    back: 'Zurück zum Blog',
    notFound: 'Beitrag nicht gefunden',
  },
  common: {
    footer: 'Die Komplettlösung zum Erstellen, Gestalten und Scannen professioneller QR-Codes.',
    privacy: 'Datenschutz',
    terms: 'AGB',
    contact: 'Kontakt',
    scanToOpen: 'Scannen, um auf dem Handy zu öffnen',
    help: 'Hilfe',
    free: 'Kostenlos',
    product: 'Produkt',
    resources: 'Ressourcen',
    company: 'Unternehmen',
    api: 'API (bald verfügbar)',
    systemStatus: 'Systemstatus: stabil',
    footerDesc:
      'YesQRCode ist der schnellste Weg zu hochwertigen QR-Codes – privat, sicher und dauerhaft kostenlos für alle Einsatzbereiche.',
  },
};
